{%/* taken from https://github.com/formio/formio.js/blob/v4.12.7/src/templates/bootstrap/file/form.ejs */%}
{% if (!ctx.self.imageUpload) { %}
  <ul class="list-group list-group-striped">
    <li class="list-group-item list-group-header hidden-xs hidden-sm">
      <div class="row">
        {% if (!ctx.disabled) { %}
          <div class="col-md-1"></div>
        {% } %}
        <div id="{{ctx.instance.id}}-{{ctx.component.key}}-file-list-header-filename" class="col-md-{% if (ctx.self.hasTypes) { %}7{% } else { %}9{% } %} openforms-content openforms-content--bold">{{ctx.t('File Name')}}</div>
        <div id="{{ctx.instance.id}}-{{ctx.component.key}}-file-list-header-filesize" class="col-md-2 openforms-content openforms-content--bold">{{ctx.t('Size')}}</div>
        {% if (ctx.self.hasTypes) { %}
          <div id="{{ctx.instance.id}}-{{ctx.component.key}}-file-list-header-filetype" class="col-md-2 openforms-content openforms-content--bold">{{ctx.t('Type')}}</div>
        {% } %}
      </div>
    </li>
    {% ctx.files.forEach(function(file) { %}
      <li class="list-group-item">
        <div class="row">
          {% if (!ctx.disabled) { %}
            <div class="col-md-1">
              <button type="button" class="utrecht-button utrecht-button--subtle utrecht-button--danger" ref="removeLink" title="{{ctx.t('Remove')}}">
                <i class="{{ctx.iconClass('trash-can')}}" aria-hidden="true"></i>
                <span class="sr-only">{{ctx.t('removeFileMessage', {fileName: file.originalName || file.name})}}</span>
              </button>
            </div>
          {% } %}
          <div class="col-md-{% if (ctx.self.hasTypes) { %}7{% } else { %}9{% } %}" aria-labelledby="{{ctx.instance.id}}-{{ctx.component.key}}-file-list-header-filename">
            {% if (ctx.component.uploadOnly) { %}
              {{{file.originalName || file.name}}}
            {% } else { %}
              <a href="{{file.url || '#'}}" target="_blank" ref="fileLink" class="utrecht-link utrecht-link--openforms"> {{{file.originalName || file.name}}}</a>
            {% } %}
          </div>
          <div class="col-md-2" aria-labelledby="{{ctx.instance.id}}-{{ctx.component.key}}-file-list-header-filesize">
            {{ctx.fileSize(file.size)}}
          </div>
          {% if (ctx.self.hasTypes) { %}
            <div class="col-md-2" aria-labelledby="{{ctx.instance.id}}-{{ctx.component.key}}-file-list-header-filetype">
              {% if (!ctx.disabled) { %}
                <select class="file-type" ref="fileType">
                  {% ctx.component.fileTypes.map(function(type) { %}
                    <option class="test" value="{{ type.value }}" {% if (type.label === file.fileType) { %}selected="selected"{% } %}>{{ type.label }}</option>
                  {% }); %}
                </select>
              {% } else { %}
                {{file.fileType}}
              {% } %}
            </div>
          {% } %}
        </div>
      </li>
    {% }) %}
  </ul>
{% } else { %}
  <div>
    {% ctx.files.forEach(function(file) { %}
      <div>
        <span>
          <img ref="fileImage" src="" alt="{{{file.originalName || file.name}}}" style="width:{{ctx.component.imageSize}}px">
          {% if (!ctx.disabled) { %}
            <button type="button" class="utrecht-button utrecht-button--subtle utrecht-button--danger" ref="removeLink" title="{{ctx.t('Remove')}}">
              <i class="{{ctx.iconClass('trash-can')}}" aria-hidden="true"></i>
              <span class="sr-only">{{ctx.t('removeFileMessage', {fileName: file.originalName || file.name})}}</span>
            </button>
          {% } %}
        </span>
      </div>
    {% }) %}
  </div>
{% } %}
{% if (!ctx.disabled && ((ctx.component.multiple && (!ctx.component.maxNumberOfFiles || ctx.files.length < ctx.component.maxNumberOfFiles)) || !ctx.files.length)) { %}
  {% if (ctx.self.useWebViewCamera) { %}
    <div class="fileSelector">
      <button class="btn btn-primary {{ctx.ofPrefix}}-button--primary utrecht-button utrecht-button--html-button utrecht-button--primary-action" ref="galleryButton"><i class="fa fa-book" aria-hidden="true"></i> {{ctx.t('Gallery')}}</button>
      <button class="btn btn-primary {{ctx.ofPrefix}}-button--primary utrecht-button utrecht-button--html-button utrecht-button--primary-action" ref="cameraButton"><i class="fa fa-camera" aria-hidden="true"></i> {{ctx.t('Camera')}}</button>
    </div>
  {% } else if (!ctx.self.cameraMode) { %}
    <div class="fileSelector" ref="fileDrop" {{ctx.fileDropHidden ? 'hidden' : ''}}>
      <i class="{{ctx.iconClass('cloud-upload')}}" aria-hidden="true"></i>

        {% if (ctx.component.multiple) { %}
          {{ctx.t('Drop files,')}}
        {% } else { %}
          {{ctx.t('Drop a file,')}}
        {% } %}

        {% if (ctx.self.imageUpload) { %}
          <a href="#" ref="toggleCameraMode" class="utrecht-link utrecht-link--openforms"><i class="fa fa-camera" aria-hidden="true"></i> {{ctx.t('Use Camera,')}}</a>
        {% } %}

        {{ctx.t('or')}}

        <a id="{{ctx.instance.id}}-{{ctx.component.key}}" href="#" ref="fileBrowse" class="browse utrecht-link utrecht-link--openforms" aria-label="{% if (ctx.component.multiple) { %} {{ctx.t('browseFiles', {fileFieldLabel: ctx.component.label})}} {% } else { %} {{ctx.t('browseFile', {fileFieldLabel: ctx.component.label})}} {% } %}">{{ctx.t('browse')}}</a>

        {% if (ctx.component.multiple) { %}
          {{ctx.t('to attach files.')}}
        {% } else { %}
          {{ctx.t('to attach a file.')}}
        {% } %}

        {% if (ctx.component.fileMaxSize) { %}
          {{ctx.t('maxFileSizeMessage', {maxFileSize: ctx.component.fileMaxSize})}}
        {% } %}
    </div>
  {% } else { %}
    <div>
      <video class="video" autoplay="true" ref="videoPlayer"></video>
    </div>
    <button class="btn btn-primary {{ctx.ofPrefix}}-button {{ctx.ofPrefix}}-button--primary utrecht-button utrecht-button--html-button utrecht-button--primary-action" ref="takePictureButton"><i class="fa fa-camera" aria-hidden="true"></i> {{ctx.t('Take Picture')}}</button>
    <button class="btn btn-primary {{ctx.ofPrefix}}-button {{ctx.ofPrefix}}-button--primary utrecht-button utrecht-button--html-button utrecht-button--primary-action" ref="toggleCameraMode">{{ctx.t('Switch to file upload')}}</button>
  {% } %}
{% } %}
{% ctx.statuses.forEach(function(status) { %}
  <div class="file {{status.status === 'error' ? ' has-error' : ''}}">
    <div class="row">
      <div class="fileName col-form-label">
        <span class="fileName__file">{{{status.originalName}}}</span>
      </div>
    </div>
    <div class="row">
      <a role="button" ref="fileStatusRemove" title="{{ctx.t('Remove')}}" href="#">
        <i class="{{ctx.iconClass('trash-can')}}" aria-hidden="true"></i>
        <span class="sr-only">{{ctx.t('removeFileMessage', {fileName: status.originalName})}}</span>
      </a>
      <div class="fileSize col-form-label col-sm-2 text-right">{{ctx.fileSize(status.size)}}</div>
    </div>
    {% if (status.status === 'progress') { %}
      <div class="openforms-loading">
        <span class="openforms-loading__spinner"></span>
        <div>{{ctx.t('Uploading file...')}}</div>
      </div>
    {% } else if (status.status === 'error') { %}
      <div class="alert alert-danger bg-{{status.status}}">{{{ctx.t(status.message)}}}</div>
    {% } else { %}
      <div class="bg-{{status.status}}">{{{ctx.t(status.message)}}}</div>
    {% } %}
  </div>
{% }) %}
{% if (!ctx.component.storage || ctx.support.hasWarning) { %}
  <div class="alert alert-warning">
    {% if (!ctx.component.storage) { %}
      <p>{{ctx.t('No storage has been set for this field. File uploads are disabled until storage is set up.')}}</p>
    {% } %}
    {% if (!ctx.support.filereader) { %}
      <p>{{ctx.t('File API & FileReader API not supported.')}}</p>
    {% } %}
    {% if (!ctx.support.formdata) { %}
      <p>{{ctx.t("XHR2's FormData is not supported.")}}</p>
    {% } %}
    {% if (!ctx.support.progress) { %}
      <p>{{ctx.t("XHR2's upload progress isn't supported.")}}</p>
    {% } %}
  </div>
{% } %}
